'use strict';

var React = require('react');

var SvgViewportNarrowIcon = function SvgViewportNarrowIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M7.75 5c0-.966.784-1.75 1.75-1.75h1c.966 0 1.75.784 1.75 1.75v1.76a.75.75 0 0 1-1.5 0v-1.76a.25.25 0 0 0-.25-.25h-1a.25.25 0 0 0-.25.25v1.76a.75.75 0 0 1-1.5 0v-1.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 12.49a.75.75 0 0 1 .75.75v1.76c0 .138.112.25.25.25h1a.25.25 0 0 0 .25-.25v-1.76a.75.75 0 0 1 1.5 0v1.76a1.75 1.75 0 0 1-1.75 1.75h-1a1.75 1.75 0 0 1-1.75-1.75v-1.76a.75.75 0 0 1 .75-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 10c0 .414.336.75.75.75h2.44l-.72.72a.75.75 0 1 0 1.06 1.06l2-2a.75.75 0 0 0 0-1.06l-2-2a.75.75 0 1 0-1.06 1.06l.72.72h-2.44a.75.75 0 0 0-.75.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.25 10.75a.75.75 0 0 0 0-1.5h-2.44l.72-.72a.75.75 0 0 0-1.06-1.06l-2 2a.75.75 0 0 0 0 1.06l2 2a.75.75 0 1 0 1.06-1.06l-.72-.72h2.44Z"
  }));
};
SvgViewportNarrowIcon.displayName = "ViewportNarrowIcon";

exports.SvgViewportNarrowIcon = SvgViewportNarrowIcon;
